import { ClassHelper } from 'components/lib';
import Style from './label.tailwind.js';

interface LabelProps {
  text?: string;
  for?: string;
  required?: boolean;
  className?: string;
  // Label forwards its whole props object to ClassHelper, which treats any
  // truthy key matching a style name as a class flag.
  [key: string]: unknown;
}

export function Label(props: LabelProps) {
  const labelStyle = ClassHelper(Style, props);

  return (
    <label className={labelStyle} htmlFor={props.for}>
      {props.text}
    </label>
  );
}
